export default __webpack_public_path__ + "static/media/blog04.742c1357.png";